import type { Handleiding } from './soort';

export const hu: Handleiding = {
  code: 'hu',
  titel: 'Útmutató',
  inleiding:
    'Az Ask Gio Tolk két olyan ember beszélgetését fordítja, akik nem beszélik egymás nyelvét. Lentebb megtalálod, mit csinál mindegyik gomb.',
  knop: 'Útmutató megnyitása',
  sluiten: 'Bezárás',
  groepGebruik: 'Beszélgetni',
  groepBeheer: 'Beállítás és kezelés',
  delen: [
    {
      titel: 'Beszéd',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Beszélj',
          uitleg:
            'Koppints egyszer a kezdéshez. A felvétel magától leáll, amint bő egy másodpercig csendben vagy, vagy ha még egyszer koppintasz. Egy perc után mindenképp leáll.',
        },
        {
          kop: 'Egyszerre csak egy hang',
          uitleg:
            'Amíg az alkalmazás beszél, nem tudsz felvenni. És amíg te veszel fel, a beérkező fordítás megvárja, míg befejezed. Különben a mikrofonod felveszi az alkalmazást, és azt hiszi, hogy te mondtad.',
        },
        {
          kop: 'Ide írd az üzenetedet',
          uitleg:
            'A beszéd mellett működik, és ugyanazon a fordításon megy át. Az enter elküldi, a shift és az enter új sort kezd.',
        },
        {
          kop: 'Idő a javításra',
          uitleg:
            'Itt állítod be, hány másodperced van átolvasni a leírt mondatodat, mielőtt elmegy. Nullán azonnal elmegy.',
        },
        {
          kop: 'Mindig magad nézd át és küldd el',
          uitleg:
            'Nincs többé óra. Minden mondat megvárja, míg megnyomod a küldést. Annak, aki minden mondatot át akar nézni.',
        },
        {
          kop: 'A fordítás azonnali lejátszása',
          uitleg:
            'Be van kapcsolva. Kapcsold ki, ha inkább előbb olvasnál, és magad döntenéd el, mikor hallgatod meg.',
        },
      ],
    },
    {
      titel: 'Üzenetek olvasása',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Ami nagyban van',
          uitleg:
            'Ami a TE nyelveden van, az nagyban jelenik meg. A saját mondatodnál ez az eredeti szöveged, hogy ellenőrizhesd, jól értett-e az alkalmazás. A másik mondatánál a fordítás.',
        },
        {
          kop: 'Az eredeti vagy a fordítás kinyitása',
          uitleg: 'A másik nyelv alatta van, összecsukva. Koppints a sorra a megnyitáshoz.',
        },
        {
          kop: 'A kis háromszög',
          uitleg: 'Újra lejátssza a fordítást.',
        },
        {
          kop: 'A beszélő fej',
          uitleg:
            'A másik saját felvételét játssza le. Csak KIMONDOTT üzenetnél jelenik meg, és csak akkor, ha a „küldd el a saját hangodat is” be van kapcsolva. Egy begépelt üzenetnek nincs felvétele.',
        },
      ],
    },
    {
      titel: 'Gombok a képernyő tetején',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Mínusz és plusz',
          uitleg: 'Kisebbé vagy nagyobbá teszi a szöveget. Öt lépésben, és megmarad.',
        },
        {
          kop: 'A mikrofon',
          uitleg: 'Elrejti a beszédgombot, ha úgyis csak gépelsz. Ez helyet spórol.',
        },
        {
          kop: 'A billentyűzet',
          uitleg:
            'Elrejti a szövegmezőt. A kettő közül mindig marad egy bekapcsolva, különben már semmit sem tudnál mondani.',
        },
      ],
    },
    {
      titel: 'Belépés',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Milyen nyelven beszélsz',
          uitleg:
            'Ez a választás a gombok és az üzenetek nyelvét is meghatározza. Mindketten más képernyőt láttok tehát, és ez a szándék.',
        },
        {
          kop: 'A hangod a fordításban',
          uitleg:
            'Válaszd ki, férfiként vagy nőként szólalsz-e meg. Ez HOZZÁD tartozik, nem a szobához: mindkét résztvevő külön választ.',
        },
        {
          kop: 'Engedély a mikrofonhoz',
          uitleg:
            'A böngésző belépéskor kéri. Ha nemet mondasz, gépelni akkor is tudsz. Az engedélyt később is megadhatod a címsorban lévő lakattal.',
        },
      ],
    },
    {
      titel: 'Lent, összecsukva',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Biztonsági szólista',
          uitleg:
            'Szavak, amelyeket mindig ugyanúgy kell fordítani: nevek, szakkifejezések, márkák. Az egész szobára érvényes.',
        },
        {
          kop: 'A beállítások módosítása',
          uitleg:
            'A nyelv, a hang, a hangnem és a helyesírás-javítás a beszélgetés KÖZBEN is átállítható. Amit itt módosítasz, az azonnal érvényes mindkettőtökre.',
        },
      ],
    },
    {
      titel: 'Beszélgetés indítása',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'A beszélgetés neve',
          uitleg:
            'Üresen is maradhat. Csak a képernyőd tetején látszik, hogy tudd, kivel beszélsz.',
        },
        {
          kop: '1. és 2. beszélő',
          uitleg:
            'Ennek a beszélgetésnek a két nyelve. Aki előbb lép be, az kapja az első helyet. A nyelveket később is felcserélheted.',
        },
        {
          kop: 'A fordítás hangneme',
          uitleg:
            'Balra a tegezést vagy a magázást választod, jobbra a hangulatot: semleges, baráti, üzleti, hivatalos vagy páros. Iránymutatás nélkül a modell szinte mindig a formális alakot választja, és ez egy hétköznapi beszélgetésben távolságtartónak hangzik.',
        },
        {
          kop: 'Küldd el a saját hangodat is',
          uitleg:
            'A másik a fordítás mellett a te saját felvételedet is hallhatja. Hasznos, ha nyelvet tanulsz. Kényes beszélgetésnél kapcsold ki: aki megkapja a felvételt, meg is tarthatja.',
        },
        {
          kop: 'Javítsd a helyesírási hibákat a saját szövegedben',
          uitleg:
            'Be van kapcsolva. Kapcsold ki, hogy lásd, mit értett valójában a modell. Ha ekkor furcsa mondat jön ki, tudod, hogy félreértette-e, vagy jól értette és utána simította el.',
        },
        {
          kop: 'PIN-kóddal',
          uitleg:
            'A kódot szóban add tovább, ne ugyanabban az üzenetben, mint a linket. Ez véd egy továbbküldött link ellen.',
        },
        {
          kop: 'A QR-kód',
          uitleg:
            'Olvastasd be a másikkal, vagy küldd el a linket. Egy szoba négy óra után magától lejár.',
        },
      ],
    },
    {
      titel: 'Mi történik a beszélgetéseddel',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'A szöveg nem marad meg',
          uitleg:
            'Amit mondtok, nem kerül az adatbázisba. Csak az, hogy mikor és mennyit beszéltetek, a költségek miatt.',
        },
        {
          kop: 'A felvételek maguktól eltűnnek',
          uitleg: 'A hang tíz percig marad a memóriában, aztán elmegy.',
        },
        {
          kop: 'A szoba lejár',
          uitleg: 'A létrehozás után négy órával. Utána a link már nem működik.',
        },
        {
          kop: 'Van rá keret',
          uitleg:
            'Szobánként és havonta. Ha betelik, az alkalmazás abbahagyja a fordítást, és ezt meg is mondja. Ez nem hiba.',
        },
      ],
    },
  ],
};
